module.exports = __webpack_public_path__ + "static/media/noun-users-4299472-142350.e28687f3.svg";